import "./index.css";
import AppOld from "./AppOld";
import { App as MainWebsite } from "./MainWebsite";

export const App = () => {
  if (typeof window !== "undefined" && window.location.pathname === "/old") {
    return <AppOld />;
  }

  return <MainWebsite />;
};

export default App;
